/**
 * A conta da tela de Criativos que não é desenho: o período escolhido virando
 * datas, e a ordem da tabela. Fora do componente para caber num teste sem DOM
 * (`criativos.test.jsx`).
 */

/** "Sem criativo" na URL da mesa — MESMO literal de `SEM_CRIATIVO` em src/criativos.ts. */
export const SEM_CRIATIVO = "__sem__";

/** Os recortes de tempo que o escritório pede, na ordem da fileira. */
export const PERIODOS = [
  { id: "hoje", rotulo: "Hoje" },
  { id: "7", rotulo: "7 dias" },
  { id: "30", rotulo: "30 dias" },
  { id: "mes", rotulo: "Mês" },
  { id: "livre", rotulo: "Escolher" },
];

const valido = (d) => /^\d{4}-\d{2}-\d{2}$/.test(d ?? "");

/** AAAA-MM-DD somando dias a uma data pura, sem fuso no meio. */
const somar = (dia, n) => new Date(Date.parse(`${dia}T12:00:00Z`) + n * 86_400_000).toISOString().slice(0, 10);

/**
 * O período vira `{ de, ate }`. `hoje` vem de fora (o dia de quem olha) para a
 * conta ser testável; "7 dias" inclui hoje, como o escritório conta a semana.
 * "Escolher" usa as datas da URL e cai no mês quando elas faltam ou vêm trocadas.
 */
export function periodoDe(id, hoje, de = "", ate = "") {
  if (id === "hoje") return { de: hoje, ate: hoje };
  if (id === "7") return { de: somar(hoje, -6), ate: hoje };
  if (id === "30") return { de: somar(hoje, -29), ate: hoje };
  const doMes = { de: `${hoje.slice(0, 8)}01`, ate: hoje };
  if (id === "livre") {
    return valido(de) && valido(ate) && de <= ate ? { de, ate } : doMes;
  }
  return doMes;
}

/*
 * A ordem da tabela. Custo nulo (sem gasto lançado) vai SEMPRE para o fim, nos
 * dois sentidos: ordenar por "custo por lead" e ver primeiro os criativos sem
 * custo nenhum esconderia o mais barato de verdade.
 */
export function ordenar(linhas, coluna, direcao = "desc") {
  const sinal = direcao === "asc" ? 1 : -1;
  return linhas.toSorted((a, b) => {
    const x = a[coluna];
    const y = b[coluna];
    if (x == null && y == null) return 0;
    if (x == null) return 1;
    if (y == null) return -1;
    if (typeof x === "string") return sinal * x.localeCompare(y, "pt-BR");
    return sinal * (x - y);
  });
}

/** "2026-09-24" → "24/09", o rótulo do eixo do gráfico. */
export const diaCurto = (dia) => `${dia.slice(8, 10)}/${dia.slice(5, 7)}`;
